import React, { useState } from 'react';

// Округление до двух знаков после запятой (чтобы не было 117.7400000000016)
const round2 = (v) => {
  const n = Number(v);
  if (isNaN(n)) return n;
  return Math.round(n * 100) / 100;
};

export default function AccountForm({ account, currentBalance, onSave, onCancel, isDebtPerson }) {
  const [name, setName] = useState(account?.name || '');
  const [includeInBalance, setIncludeInBalance] = useState(account?.includeInBalance !== false);
  const [balance, setBalance] = useState(currentBalance != null ? round2(currentBalance) : '');
  const [isCredit, setIsCredit] = useState(!!account?.isCredit);
  const [creditLimit, setCreditLimit] = useState(account?.creditLimit != null ? String(round2(account.creditLimit)) : '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const data = { name: name.trim() };
    if (isDebtPerson) {
      // Человек в долгах — счёт-долг: имя и «person» одинаковые, в общий баланс не входит
      data.isDebt = true;
      data.person = name.trim();
      data.includeInBalance = false;
    } else {
      data.includeInBalance = includeInBalance;
      data.isCredit = isCredit;
      data.creditLimit = isCredit && creditLimit !== '' && !isNaN(parseFloat(creditLimit))
        ? round2(parseFloat(creditLimit))
        : null;
    }
    // Остаток: при создании — начальный, при редактировании — корректировка
    if (balance !== '' && !isNaN(parseFloat(balance))) {
      data.balance = round2(parseFloat(balance));
    }
    onSave(data);
  };

  return (
    <form className="card" onSubmit={handleSubmit}>
      <h3>{isDebtPerson ? 'Новый человек' : (account ? 'Редактировать счёт' : 'Новый счёт')}</h3>
      <div className="form-group">
        <label>Название счёта</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Например: Зарплатная карта"
          required
        />
      </div>
      <div className="form-group">
        <label>
          {isDebtPerson
            ? 'Сумма долга (положительное — должны вам, отрицательное — вы должны)'
            : (account ? 'Остаток (будет создана корректировка)' : 'Сколько сейчас на счёте? (начальный остаток)')}
        </label>
        <input
          type="number"
          inputMode="decimal"
          step="0.01"
          value={balance}
          onChange={(e) => setBalance(e.target.value)}
          placeholder="Например: 25000"
        />
      </div>
      {!isDebtPerson && (
        <>
          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="checkbox"
                checked={includeInBalance}
                onChange={(e) => setIncludeInBalance(e.target.checked)}
              />
              Учитывать в общем балансе
            </label>
          </div>
          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="checkbox"
                checked={isCredit}
                onChange={(e) => setIsCredit(e.target.checked)}
              />
              Кредитная карта?
            </label>
          </div>
          {isCredit && (
            <div className="form-group">
              <label>Кредитный лимит</label>
              <input
                type="number"
                inputMode="decimal"
                step="0.01"
                value={creditLimit}
                onChange={(e) => setCreditLimit(e.target.value)}
                placeholder="Например: 100000"
              />
            </div>
          )}
        </>
      )}
      <div style={{ display: 'flex', gap: '8px' }}>
        <button type="submit">Сохранить</button>
        <button type="button" className="secondary" onClick={onCancel}>Отмена</button>
      </div>
    </form>
  );
}
